var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSendActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2934 19.705L17.9214 2.76222C18.1342 1.97416 17.3086 1.31793 16.5889 1.70305L1.12713 10.0343C0.537192 10.3453 0.471827 11.156 0.985997 11.5647L4.31872 14.2256C4.68081 14.5135 5.2052 14.493 5.53647 14.1655L15.0389 5.02074L8.26663 16.3356C8.02951 16.738 8.12792 17.2535 8.49001 17.5413L11.8342 20.1877C12.3484 20.5964 13.1235 20.3499 13.2934 19.705Z",
    fill: "#a890fe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSendActive);
export default __webpack_public_path__ + "static/media/ic_send_active.6e3bda8dfad69f6840890a9dc39324a6.svg";
export { ForwardRef as ReactComponent };